import Vue from 'vue'
import store from '../../store'
import FileTransformer from '../../transformers/Files/'

const save = (data) => {
  store.dispatch('catalogs/store', data)
}

export default (catalog, opts = {}) => {
  let url = `/catalogs/common/${catalog}/`

  if (typeof (opts) !== 'object') {
    opts = { id: opts }
  }
  if (opts.id) {
    url = `${url}${opts.id}/`
  }

  return Vue.$http.get(url, opts.config)
    .then((response) => {
      const catalogName = catalog.split('/').shift()

      const transformer = opts.transformer || FileTransformer[catalogName]
      let data = response.data
      if (transformer && transformer.fetch) {
        if (!!opts.id && !opts.collection) {
          data = transformer.fetch(data)
        } else {
          data = transformer.fetchCollection(data)
        }
      }

      if (!opts.id && !opts.noStore) {
        save({ type: catalog, data })
      }
      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/Files/fetch.js